import { defineMessages } from 'react-intl'

export default defineMessages({
  modalTitle: {
    id: 'containers.SupplierDashboardPage.components.TaskListWidget.components.BulkAssignProducerDialog.modalTitle',
    defaultMessage: 'Bulk Assign Producer',
  },
  producerSelect: {
    id: 'containers.SupplierDashboardPage.components.TaskListWidget.components.BulkAssignProducerDialog.producerSelect',
    defaultMessage: 'Select producer',
  },
  noProducerFound: {
    id: 'containers.SupplierDashboardPage.components.TaskListWidget.components.BulkAssignProducerDialog.noProducerFound',
    defaultMessage: 'No producer found',
  },
  successToastr: {
    id: 'containers.SupplierDashboardPage.components.TaskListWidget.components.BulkAssignProducerDialog.successToastr',
    defaultMessage: 'Producer assigned',
  },
  submitButton: {
    id: 'containers.SupplierDashboardPage.components.TaskListWidget.components.BulkAssignProducerDialog.submitButton',
    defaultMessage: 'Assign',
  },
  textAreaLabel: {
    id: 'containers.SupplierDashboardPage.components.TaskListWidget.components.BulkAssignProducerDialog.textAreaLabel',
    defaultMessage: 'Message to producer',
  }
})
